import React from 'react';
import { Spinner } from '../../components/ui';
import UserForm from './UserForm';

// Mobile UI for Users — card per user.
export default function UsersMobile({ vm }) {
  const { isAdmin, canAddUsers, event, members, loading, modal, roleOf, roleChip, openAdd, openEdit, clearDevice, canResetDevice, deviceInfo, canRemove, remove, isActive, canToggleActive, toggleActive } = vm;
  return (
    <div>
      <div className="page-head" style={{ flexWrap: 'wrap' }}>
        <h1>Members</h1>
        <span className="muted">{members.length}</span>
      </div>
      {canAddUsers && <button className="btn primary" onClick={openAdd} style={{ width: '100%', padding: 12, marginBottom: 10 }}>+ Add Member</button>}
      <div className="muted" style={{ marginBottom: 10, fontSize: 13 }}>
        {isAdmin
          ? <>Who can access <strong>{event?.EventName || 'the selected event'}</strong> and what they can do.</>
          : <>Add members who can sign in and add guests. You can remove the ones you added.</>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : members.length === 0 ? <div className="card card-pad empty">No members yet.</div> : (
          <div style={{ display: 'grid', gap: 10 }}>
            {members.map(row => {
              const role = roleOf(row);
              return (
                <div key={row.UserId} className={'card card-pad' + (isAdmin && row.SuperAdmin !== 1 ? ' row-link' : '')}
                  onClick={isAdmin && row.SuperAdmin !== 1 ? () => openEdit(row) : undefined}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                    <strong style={{ fontSize: 15 }}>{`${row.Surname || ''} ${row.Name || ''}`.trim() || '—'}</strong>
                    <div style={{ flex: 1 }} />
                    <span className={roleChip(role)}>{role}</span>
                  </div>
                  <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
                    📞 {row.MobileNumber || '—'}{row.Designation ? ` · ${row.Designation}` : ''}
                    {' · '}{deviceInfo(row).bound ? <span className="chip ok" title={deviceInfo(row).model}>{deviceInfo(row).label}</span> : <span className="chip pend">Not bound</span>}
                    {' · '}{isActive(row) ? <span className="chip ok">Active</span> : <span className="chip danger">Inactive</span>}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }} onClick={(e) => e.stopPropagation()}>
                    {isAdmin && <button className="btn light sm" disabled={row.SuperAdmin === 1} onClick={() => openEdit(row)}>Permissions</button>}
                    {canResetDevice(row) && <button className="btn light sm" onClick={() => clearDevice(row)}>Reset Device</button>}
                    {canToggleActive(row) && <button className="btn light sm" onClick={() => toggleActive(row)}>{isActive(row) ? 'Deactivate' : 'Activate'}</button>}
                    {canRemove(row) && <button className="btn danger sm" onClick={() => remove(row)}>Remove</button>}
                  </div>
                </div>
              );
            })}
          </div>
        )}

      {modal && <UserForm vm={vm} />}
    </div>
  );
}
